<!-- eslint-disable vue/no-unused-refs -->
<template>
  <div>
    <el-dialog
      title="批量录入车辆"
      :visible="visible"
      :close-on-click-modal="false"
      width="50%"
      @close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        class="import-car-info-form"
      >
        <div class="form-item-wrapper">
          <el-form-item label="所属部门" prop="deptId">
            <DeptSelect v-model="form.deptId" filterable clearable isAll />
          </el-form-item>
        </div>
        <div class="form-item-wrapper">
          <el-form-item label="采购方式" prop="purchaseType">
            <el-select
              v-model="form.purchaseType"
              clearable
              placeholder="请选择采购方式"
            >
              <el-option
                v-for="item in purchaseTypeList"
                :label="item.name"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrapper">
          <el-form-item label="车源方" prop="providerId">
            <el-select
              v-model="form.providerId"
              :disabled="!form.deptId"
              clearable
              placeholder="请选择车源方"
            >
              <el-option
                v-for="item in carProviderList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <div class="info-slot">
            <el-button type="text" @click="() => handleAddProvider('0')">新增车源方</el-button>
          </div>
        </div>
        <div class="form-item-wrapper">
          <el-form-item label="产权方" prop="propertyId">
            <el-select
              v-model="form.propertyId"
              :disabled="!form.deptId"
              clearable
              placeholder="请选择产权方"
            >
              <el-option
                v-for="item in propertyList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <div class="info-slot">
            <el-button type="text" @click="() => handleAddProvider('3')">新增产权方</el-button>
          </div>
        </div>
        <div>
          <el-form-item label="车辆信息" prop="fileAddress">
            <PublicImport
              ref="publicImport"
              bizId="BATCH_CAR_INFO_IMPORT_V2"
              accept=".xls,.xlsx"
              :disabled="fileList.length > 0"
              :inPage="true"
              :importInPage="true"
              :shardUpload="false"
              @onUploadRemove="uploadRemove"
              @onUploadFinish="uploadFinish"
            >
              <template slot="supplement">
                <div class="info-slot model-info-slot" style="top: 0">
                  <el-button type="text" @click.stop="handleAddCarType">查看车型库</el-button>
                </div>
              </template>
            </PublicImport>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          :disabled="!confirmBtnDisabled"
          @click="handleConfirm"
        >创建车辆</el-button>
      </span>
    </el-dialog>

    <HandleProvider
      ref="HandleProvider"
      type="add"
      :serviceTypeProp="serviceType"
      @handleSuccess="handleAddProviderSuccess"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HandleProvider from '@/pages/customers/servicesManage/serviceProvider/components/handleProvider.vue'
import { batchCreateCar } from '@/api/domain/vehicle'
import { getCarProvider as getCarProviderList, propertyOwnerList as getPropertyOwnerList } from '@/api/domain/cars'
import { SERVICE_TYPES, PURCHASE_TYPE_LIST } from '../../config'

export default {
  props: ['visible'],
  data() {
    return {
      form: {
        deptId: '',
        purchaseType: '',
        providerId: '',
        propertyId: '',
        fileAddress: '',
      },
      rules: {
        deptId: [
          { required: true, message: '请选择车辆所属部门', trigger: 'change' },
        ],
        fileAddress: [
          { required: true, message: '请上传车辆信息', trigger: 'change' },
        ],
      },
      // 车源方列表
      carProviderList: [],
      // 产权方列表
      propertyList: [],
      // 采购方式列表
      purchaseTypeList: PURCHASE_TYPE_LIST,
      // 服务商类型
      serviceType: SERVICE_TYPES.carProvider.value,
      fileList: [],
      fileUploading: false,
      submitLoading: false,
      isDestroyed: false,
      isBatchAdd: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    confirmBtnDisabled() {
      if (this.isBatchAdd) return false
      return this.form.deptId && this.form.fileAddress
    },
  },
  created() {
    this.form.deptId = this.userInfo.rootDeptId
    this.getPropertyOwnerList()
    this.getCarProviderList()
  },
  methods: {
    handleClose() {
      if (this.fileUploading) {
        this.$message.info('文件正在上传中，请稍后')
        return
      }
      this.$emit('toggleDialogVisible', false)
      this.isBatchAdd = false
    },
    handleCancel() {
      this.$emit('toggleDialogVisible', false)
    },
    async handleConfirm() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          this.submitLoading = true
          const extInfo = {
            purchaseType: this.form.purchaseType,
            providerId: this.form.providerId,
            propertyId: this.form.propertyId,
          }
          const data = {
            deptId: this.form.deptId || null,
            uploadType: 61, // 61:车辆信息导入
            fileOssPath: this.form.fileAddress,
            fileName: this.fileList[0].name,
            extInfo: JSON.stringify(extInfo),
          }
          batchCreateCar(data).then((res) => {
            if (res?.code === 1) {
              this.isBatchAdd = true
              this.$refs.publicImport.showImportProgress(res.data)
            }
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleAddCarType() {
      this.handleClose()
      this.$router.push({
        path: '/vehicle/carModel/list',
      })
    },
    handleAddProvider(serviceType) {
      this.serviceType = serviceType
      this.$refs.HandleProvider.handelDialogVisible = true
    },
    handleAddProviderSuccess() {
      if (this.serviceType === SERVICE_TYPES.carProvider.value) {
        this.getCarProviderList()
      } else if (this.serviceType === SERVICE_TYPES.propertyOwner.value) {
        this.getPropertyOwnerList()
      }
    },
    // 获取车源方
    async getCarProviderList() {
      try {
        const { code, data } = await getCarProviderList({
          state: 1,
          serviceType: SERVICE_TYPES.carProvider.value,
        })
        if (code === 1) {
          this.carProviderList = data.items
        } else {
          this.$message.error('获取车源方失败')
        }
      } catch (error) {
        this.$message.error('获取车源方失败')
      }
    },
    // 获取产权方
    async getPropertyOwnerList() {
      try {
        const { code, data } = await getPropertyOwnerList({
          state: 1,
          serviceType: SERVICE_TYPES.propertyOwner.value,
        })
        if (code === 1) {
          this.propertyList = data.items
        } else {
          this.$message.error('获取产权方失败')
        }
      } catch (error) {
        this.$message.error('获取产权方失败')
      }
    },
    uploadFinish(fileList) {
      this.fileList = fileList
      this.form.fileAddress = fileList[0].objectName
      this.$refs.form.clearValidate('fileAddress')
    },
    uploadRemove() {
      this.fileList = []
      this.form.fileAddress = ''
      this.isBatchAdd = false
      this.$refs.form.validateField('fileAddress')
    },
  },
  beforeDestroy() {
    this.isDestroyed = true // 在销毁前设置标志
  },
  components: {
    HandleProvider,
  },
}
</script>
<style lang="scss" scoped>
.dialogWrap-box {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
.import-car-info-form {
  display: flex;
  flex-wrap: wrap;
  padding-top: 12px;
  .form-item-wrapper {
    width: 50%;
    flex: none;
  }
}
.form-row {
  margin-bottom: 12px;
}
.info-slot {
  position: relative;
  top: -12px;
  margin-left: 100px;
}
.model-info-slot {
  display: inline-block;
  margin-left: 12px;
  top: 0;
}
.file-row {
  display: flex;
  justify-content: flex-start;
  .file-name-wrapper {
    display: flex;
    align-items: center;
    .file-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    ::v-deep .el-icon-document {
      flex: none;
      margin-right: 2px;
    }
    ::v-deep .el-icon-circle-check {
      flex: none;
      margin-left: 6px;
      color: #67c23a;
    }
  }
  .file-btns {
    flex: 1;
    display: flex;
    align-items: center;
    margin-left: 24px;
    ::v-deep .el-icon-download:hover {
      color: #409eff;
      cursor: pointer;
    }
    ::v-deep .el-icon-delete {
      margin-left: 8px;
      &:hover {
        color: #409eff;
        cursor: pointer;
      }
    }
  }
}
</style>
